import {tableTranslations, TableTranslations} from './table/table.translations.pl';
import {ProcessTimerTranslations, processTimerTranslations,} from './processTimer/processTimer.translation.pl.ts';

export type ComponentsTranslations = {
  table: TableTranslations;
  loader: {
    loading: string
  }
  narrator: {
    disable: string
    enable: string
  }
  processTimer: ProcessTimerTranslations;
  slider: {
    ariaLabel: string
  }
  textArea: {
    characterCount: string
  }
};

export const componentsTranslations: ComponentsTranslations = {
  table: tableTranslations,
  loader: {
    loading: 'Ładowanie...'
  },
  narrator: {
    disable: 'Wyłącz lektora',
    enable: 'Włącz lektora'
  },
  processTimer: processTimerTranslations,
  slider: {
    ariaLabel: 'Wybierz wartość na skali'
  },
  textArea: {
    characterCount: '{{current}}/{{max}} znaków'
  },
};
